<template>
  <div class="call-group-page" v-if="token">
    <div class="call-group-page-header pl-15 pt-5">
      <div class="meeting-category" v-if="meeting" :style="`color: ${meeting.category.color}`">
        {{meeting.category.name_kanji}}
      </div>
      <div class="logo">
        <img src="../assets/images/parts-logo-wide.png" alt="">
      </div>
      <div class="organizer-lable" v-if="isMeetingOrganizer">主催者</div>
      <div class="screen-btn" :class="{'stop-screen': isShareScreen}" @click="shareScreen"></div>
    </div>
    <div class="call-group-page-main-content">
      <div v-if="!isEnableMessageBox" class="show-messages-button" v-show="messages.length > 0" @click="isEnableMessageBox = !isEnableMessageBox"></div>
      <div v-else class="hide-messages-button" v-show="messages.length > 0" @click="isEnableMessageBox = !isEnableMessageBox"></div>
      <div class="chat-box" id="chat-box" v-show="isEnableMessageBox && messages.length > 0">
        <ul class="messages">
          <li class="message" v-for="(message, index) in messages" :key="index">
            <div class="avatar-user w-30 h-30">
              <img v-if="message.avatar" :src="`data:image/png;base64,${message.avatar}`" class="w100">
              <img v-else src="../assets/images/avatar-default.png" class="w100">
            </div>
            <div class="message-content inline-block ml-10">
            {{message.name}}: {{message.message}}
            </div>
          </li>
        </ul>
      </div>

      <div id="main-screen">
        <div class="main-screen-empty">
          メインスクリーンに映したい人を <br>
          参加者エリアから選択してください。
        </div>
        <div class="screen-container"></div>
        <div class="sharing-screen-label" :class="{'show-chat-input': isEnableChatBox}" v-show="isShareScreen">
          現在、選択した画面もしくはアプリが参加者に共有されています
        </div>
      </div>

      <div id="sub-screens" v-if="meeting">
        <div v-for="item in users"
             :key="`${item.id}`"
             class="screen-container"
             :id="`screen-container-${item.id}`">
          <section :id="`empty-screen-${item.id}`" class="empty-screen active" @click="handleClickSubScreenItem(item.id)">
            <img src="../assets/icon/empty-person.png" alt="Video Off">
            <div class="user-name">{{item.name}}</div>
          </section>
          <section :id="`screen-${item.id}`" class="screen" @click="handleClickSubScreenItem(item.id)">
            <div class="user-name">{{item.name}}</div>
          </section>
          <section :id="`share-screen-${item.id}`" class="screen" @click="handleClickSubScreenItem(item.id, true)">
            <div class="user-name">[共]{{item.name}}</div>
          </section>
        </div>
      </div>

      <div class="call-buttons top">
        <div>
          <div class="chat call-button" :class="{disabled: !isEnableChatBox}" @click="enableChatBox"></div>
          <span>チャット</span>
        </div>
        <div v-if="showOnOffVideo">
          <div class="video call-button" :class="{disabled: !isEnableVideo || !videoLocalStream}" @click="enableVideo()"></div>
          <span>カメラ</span>
        </div>
        <div>
          <div class="speaker call-button" :class="{disabled: !isEnableSpeaker}" @click="enableSpeaker"></div>
          <span>音声</span>
        </div>
        <div>
          <div class="mic call-button" :class="{disabled: !isEnableMic}" @click="enableMic"></div>
          <span>マイク</span>
        </div>
      </div>

      <div class="call-buttons bottom">
        <div v-if="$auth.user().type !== USER_TYPE_PATIENT && showExtendArea">
          <div class="extend call-button" @click="extendMeeting"></div>
          <div class="call-button-label extend" @click="extendMeeting">{{additionalTimeMinutes}}分延長</div>
        </div>
        <div class="extend-message " v-if="$auth.user().type !== USER_TYPE_PATIENT && showDisabledExtendMessage">
          <div>時間延長できません</div>
        </div>
        <div class="extend-message" v-if="$auth.user().type !== USER_TYPE_PATIENT && showCompletedExtendMessage">
          <div>まだ延長できません</div>
        </div>
        <div class="end-call-label" @click="endCall">
          <div class="end-call call-button" @click="endCall"></div>
          <div class="call-button-label end-call">通話終了</div>
        </div>
      </div>
      <div class="remain-area">
        <div class="remain-label">
          残り時間：
        </div>
        <div class="remain-times" v-text="remainTimes">
          --:--:--
        </div>
      </div>

      <div class="chat-input-container" v-if="isEnableChatBox">
        <textarea @keyup.enter="sendMessage($event)" v-model="message" placeholder="テキストを入力"></textarea>
        <span class="send-button" @click="sendMessage()"></span>
        <div class="close-button" @click="isEnableChatBox = false"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AgoraRTC from 'agora-rtc-sdk-ng'
import AgoraRTM from 'agora-rtm-sdk'
import moment from 'moment'
import _ from 'lodash'
import {USER_TYPE_PATIENT, MEETING_CATEGORY_MEDICATION} from '@/const'
import {isShareScreenStream, getUidFromShareScreenUid, apiErrorDialog} from '@/helpers'
import {isJoinButtonEnabled} from '@/utils/joinWindow'
import MeetingsApi from '@/api/meeting'
import UsersApi from '@/api/users'
import MasterDataApi from '@/api/master'

// AgoraRTC.Logger.setLogLevel(3)
export default {
  data () {
    return {
      isEnableMessageBox: true,
      isEnableChatBox: false,
      isEnableVideo: true,
      isEnableSpeaker: true,
      isEnableMic: true,
      isShareScreen: false,
      videoClient: null,
      shareScreenClient: null,
      videoLocalStream: null,
      audioLocalStream: null,
      shareScreenLocalStream: null,
      shareScreenLocalAudioStream: null,
      streamList: [],
      displayMode: 'pip',
      mainId: null,
      count: 0,
      readyState: false,
      message: '',
      messages: [],
      token: null,
      channel: null,
      uid: null,
      udeviceid: null,
      videoProfile: '480p',
      showOnOffVideo: true,
      MEETING_CATEGORY_MEDICATION,
      meeting: null,
      users: [],
      hasNextMeeting: false,
      endMeetingConfirmed: false,
      isMeetingOrganizer: false,
      participants: [],
      beforeMeetingFinish: null,
      callReloadUsers: null,
      // RTM
      rtmClient: null,
      rtmChannel: null,
      rtmToken: null,
      // CloudProxy
      rtcCloudProxy: false,
      //
      streamTypes: { 'userId': 0, 'audio': 1, 'video': 2 },
      agoraPlayerPrefix: 'agora-video-player-',
      //
      timers: {
        timers: [],
        intervals: []
      },
      remainTimesTimerIndex: 0,
      shareScreenTimerIndex: 1,
      updateAttendieeTimerIndex: 2,
      handleCanExtendMeetingIndex: 3,
      //
      remainTimes: '--:--:--',
      disabledExtendMeeting: true,
      showExtendArea: false,
      showDisabledExtendMessage: false,
      showCompletedExtendMessage: false,
      additionalTimeMinutes: 30,
      //
      USER_TYPE_PATIENT
    }
  },
  computed: {
    //
  },
  methods: {
    handleJoinUnavailable (meetingId = null) {
      const $ = this
      return this.$alert('この予約は終了しました。参加できません。', '', {
        confirmButtonText: this.$auth.check() ? '予約詳細へ戻る' : 'OK',
        cancelButtonText: '',
        forceRender: true,
        type: 'warning'
      }).then(() => {
        if (this.$auth.check() && meetingId) {
          $.$router.push({name: 'meetings.show', params: {id: meetingId}})
        } else {
          $.$router.push({name: 'home'})
        }
      })
    },
    subscribeStreamEvents (client) {
      const $ = this
      const cl = client
      cl.on('user-joined', (user) => {
        console.log(`user-joined event fired. [${user.uid}]`)
        $.addInUsers(user.uid)
      })
      cl.on('user-info-upated', (uid, msg) => {
        console.log(`user-info-update: ${msg}`)
      })
      cl.on('user-published', async (user, streamType) => {
        console.log(`user-published event fired. [${user.uid}(${streamType})]`)
        await cl.subscribe(user, streamType)
        $.addStream(user.uid, user.videoTrack, user.audioTrack, streamType)
      })
      cl.on('user-unpublished', async (user, streamType) => {
        $.removeStream(user.uid, streamType)
      })
      cl.on('user-left', async (user, reason) => {
        $.removeUserInList(user.uid, reason)
      })
    },
    async addInUsers (userId) {
      if (isShareScreenStream(userId)) return

      let user = {id: userId}
      const index = _.findIndex(this.users, n => n.id === parseInt(userId))
      if (index < 0) {
        if (!this.memberInMeeting()) {
          try {
            const userRes = await UsersApi.show(user.id, this.meeting.key)
              .catch((error) => {
                // for guest user
                if (error.response.status === 404) return
                apiErrorDialog(this, error)
              })
            user.name = userRes.data.data.name
          } catch (e) {
            const uid = this.getGuestId(user.id)
            user.name = `ゲスト${uid}`
          }
        } else {
          user.name = this.meeting.participants.find(n => n.id === userId).name
        }

        if (this.uid === userId) {
          this.users = [user, ...this.users]
        } else {
          this.users = [...this.users, user]
        }
      }
    },
    async addStream (userId, videoStream, audioStream, streamType, shareScreen = false) {
      if (isShareScreenStream(userId)) {
        const uid = getUidFromShareScreenUid(userId)
        if (!uid || uid === this.uid) return
        this.timers.timers[this.shareScreenTimerIndex] = setTimeout(() => {
          if (document.querySelector(`#share-screen-${uid}`)) {
            document.querySelector(`#share-screen-${uid}`).classList.add('active')
            if (videoStream) videoStream.play(`share-screen-${uid}`)
            if (audioStream) audioStream.play()
            this.makeSubScreen()
            this.makeMainScreen(uid, true)
          }
        }, 1000)
      } else {
        if (shareScreen) return

        this.timers.timers[this.shareScreenTimerIndex] = setTimeout(() => {
          this.updateAttendieeSubScreen(userId, streamType, videoStream, audioStream)
        })
      }
      this.addInStreamList(userId, videoStream, audioStream, streamType)
    },
    updateAttendieeSubScreen (userId, streamType, videoStream, audioStream) {
      try {
        if (videoStream && streamType === 'video') {
          document.querySelector(`#empty-screen-${userId}`).classList.remove('active')
          document.querySelector(`#screen-${userId}`).classList.add('active')
          videoStream.play(`screen-${userId}`)
        } else if (audioStream) {
          if (this.uid !== userId) audioStream.play()
        }
      } catch (e) {
        this.timers.timers[this.updateAttendieeTimerIndex] = setTimeout(() => {
          this.updateAttendieeSubScreen(userId, streamType, videoStream, audioStream)
        }, 3000)
      }
    },
    addInStreamList (userId, videoStream, audioStream) {
      let savePosition = -1
      let stack = [userId]
      stack[this.streamTypes['video']] = videoStream
      stack[this.streamTypes['audio']] = audioStream
      this.streamList = this.streamList.map((items, index) => {
        if (items[this.streamTypes['userId']] === userId) {
          // exists item
          savePosition = index
          stack[this.streamTypes['video']] = videoStream || items[this.streamTypes['video']]
          stack[this.streamTypes['audio']] = audioStream || items[this.streamTypes['audio']]
          return stack
        }
        return items
      })

      if (savePosition < 0) {
        // new item
        this.streamList = [
          stack, ...this.streamList
        ]
      }
    },
    removeStream (uid, streamType) {
      let $ = this
      this.streamList.map((items, index) => {
        if (items[$.streamTypes['userId']] === uid) {
          if (items[$.streamTypes[streamType]]) items[$.streamTypes[streamType]].stop()
          let targetUid = uid
          if (isShareScreenStream(uid)) {
            targetUid = getUidFromShareScreenUid(uid)
          }
          if (streamType === 'video') {
            document.querySelector(`#empty-screen-${targetUid}`).classList.add('active')
            document.querySelector(`#screen-${targetUid}`).classList.remove('active')
          }
          const tempList = [...this.streamList]
          $.streamList = tempList
          if (isShareScreenStream(uid)) {
            document.querySelector(`#share-screen-${targetUid}`).classList.remove('active')
            // document.querySelector(`#share-screen-${targetUid} #${this.agoraPlayerPrefix}${targetUid}`).remove()
            document.querySelector(`#screen-${targetUid}`).classList.remove('active')
          }
        }
      })
    },
    removeUserInList (userId, reason) {
      if (reason !== 'Quit') return
      _.remove(this.users, n => n.id === userId)
      this.users = [...this.users]
    },
    muteVideo (uid) {
      if (document.querySelector(`#${this.agoraPlayerPrefix}${uid}`)) document.querySelector(`#${this.agoraPlayerPrefix}${uid}`).classList.add('mute-video')
    },
    unmuteVideo (uid) {
      if (document.querySelector(`#${this.agoraPlayerPrefix}${uid}`)) document.querySelector(`#${this.agoraPlayerPrefix}${uid}`).classList.remove('mute-video')
    },
    enableChatBox () {
      this.isEnableChatBox = !this.isEnableChatBox
    },
    async enableVideo () {
      const $ = this

      if (!$.videoLocalStream) return

      // don't close because want to continue to use the connection of the track instannce for video device.
      if (!$.isEnableVideo) {
        $.videoClient.publish($.videoLocalStream).then(() => {
          document.querySelector(`#${$.agoraPlayerPrefix}${$.videoLocalStream._ID}`).classList.remove('mute-video')
          $.isEnableVideo = true
        })
      } else {
        $.videoClient.unpublish($.videoLocalStream).then(() => {
          document.querySelector(`#${$.agoraPlayerPrefix}${$.videoLocalStream._ID}`).classList.add('mute-video')
          $.isEnableVideo = false
        })
      }
    },
    enableSpeaker () {
      const $ = this
      $.isEnableSpeaker = !$.isEnableSpeaker
      $.streamList.forEach(items => {
        const uid = items[$.streamTypes['userId']]
        if (uid !== $.uid) {
          if (items[$.streamTypes['audio']]) {
            if ($.isEnableSpeaker) {
              items[$.streamTypes['audio']].play()
            } else {
              items[$.streamTypes['audio']].stop()
            }
          }
        }
      })
    },
    enableMic () {
      this.isEnableMic = !this.isEnableMic
      this.audioLocalStream.setMuted(!this.isEnableMic)
    },
    async _leave () {
      if (this.audioLocalStream || this.videoLocalStream) {
        // if (this.videoClient) await this.videoClient.unpublish([this.audioLocalStream, this.videoLocalStream])
        if (this.videoLocalStream) {
          this.videoLocalStream.stop()
          this.videoLocalStream.close()
        }
        if (this.audioLocalStream) {
          this.audioLocalStream.stop()
          this.audioLocalStream.close()
        }
      }
      if (this.videoClient) await this.videoClient.leave()
      if (this.videoClient && this.rtcCloudProxy) this.videoClient.stopProxyServer()

      if (this.shareScreenClient) {
        this._leaveShareScreen()
      }
      this._leaveRtm()
      this._clearTimers()
    },
    _clearTimers () {
      for (let timer of this.timers.timers) {
        clearTimeout(timer)
      }
      for (let interval of this.timers.intervals) {
        clearTimeout(interval)
      }
    },
    async _leaveShareScreen () {
      const $ = this
      $.isShareScreen = false

      if (this.shareScreenClient) await this.shareScreenClient.unpublish(this.shareScreenLocalStream)
      if (this.shareScreenLocalStream) {
        this.shareScreenLocalStream.close()
      }
      if (this.shareScreenLocalAudioStream) {
        this.shareScreenLocalAudioStream.close()
      }
      if (this.shareScreenClient) await this.shareScreenClient.leave()
      if (this.videoClient && this.shareScreenClient) this.shareScreenClient.stopProxyServer()
    },
    async _leaveRtm () {
      this.rtmClient.logout()
    },
    async handleRamainTimes () {
      this.updateRemainTimes()
      this.timers.intervals[this.remainTimesTimerIndex] = setInterval(this.updateRemainTimes, 1000)
      this.timers.intervals[this.handleCanExtendMeetingIndex] = setInterval(this.handleCanExtendMeeting, 5 * 60 * 1000)
    },
    async updateRemainTimes () {
      let second = -moment().diff(this.meeting.end_at, 'seconds')
      if (second < 0) {
        second = 0
      }

      if (!this.disabledExtendMeeting) {
        if (second < (60 * this.additionalTimeMinutes) && second > 0) {
          this.showCompletedExtendMessage = false
          this.showExtendArea = true
        } else if (second >= (60 * this.additionalTimeMinutes) || second === 0) {
          this.showCompletedExtendMessage = true
          this.showExtendArea = false
        }
      }

      let remainTimes = []
      if (second >= 3600) {
        remainTimes.push(String(parseInt(second / 3600)).padStart(2, '0'))
        second %= 3600
      }
      remainTimes.push(String(parseInt(second / 60)).padStart(2, '0'))
      remainTimes.push(String(second % 60).padStart(2, '0'))
      this.remainTimes = remainTimes.join(':')
    },
    async handleCanExtendMeeting () {
      try {
        let response = await this.$http.get(`/meetings/${this.meeting.id}/extends/${this.meeting.end_at}`)
          .catch((error) => {
            // for guest user
            if (error.response.status === 401) return
            apiErrorDialog(this, error)
          })
        this.disabledExtendMeeting = !response.data.data.can_extend
        this.showDisabledExtendMessage = this.disabledExtendMeeting
        this.showExtendArea = !this.disabledExtendMeeting
        if (response.data.data.meeting_end_at) {
          this.meeting.end_at = response.data.data.meeting_end_at
        }
        return response.data.data.can_extend
      } catch (e) {
        apiErrorDialog(this, e.getMessage())
      }

      return false
    },
    async extendMeeting () {
      const $ = this
      try {
        let response = await $.$http.post(`/meetings/${$.meeting.id}/extends`)
          .catch((error) => {
            $.disabledExtendMeeting = true
            $.showDisabledExtendMessage = true
            $.showCompletedExtendMessage = false
            $.showExtendArea = false
            // for guest user
            if (error.response.status === 401) return
            apiErrorDialog($, error)
          })
        $.meeting = response.data.data
      } catch (e) {
        console.log(e)
        $.$message.error('延長できませんでした')
        return
      }
      $.$message.info('予約終了時間を延長しました')
      $.showCompletedExtendMessage = true
      $.showExtendArea = false
    },
    endCall () {
      const r = confirm('本当に通話を終了しますか？')
      if (r) {
        try {
          this._leave()
          this.endMeetingConfirmed = true
        } catch (e) {
          console.log(e)
        }
        this.$router.push({name: 'meetings.show', id: this.meeting.id})
      }
    },
    async shareScreen () {
      const $ = this
      if (!$.isShareScreen) {
        const ids = $.users.map(item => item.id)
        let screenShared = false
        _.forEach(ids, id => {
          if (isShareScreenStream(id)) screenShared = true
        })
        if (screenShared) return alert('他のユーザーが画面を共有しているため、画面共有できません。')

        let res = null
        if ($.$router.currentRoute.name === 'meetings.call') {
          res = await $.$http.get(`generate-token?id=${$.$route.params.id}&share_screen=true`)
        } else if (this.$router.currentRoute.name === 'shareCall') {
          res = await $.$http.get(`generate-token?key=${$.$route.query.key}&share_screen=true&uid=${$.uid}`)
        }
        const tokenData = res.data.data

        // Notice: When there is no available server in Japan, the SDK throws an error instead of connecting to servers in another region.
        AgoraRTC.setArea({
          areaCode: 'JAPAN'
        })
        $.shareScreenClient = AgoraRTC.createClient({mode: 'live', codec: 'h264'})
        if ($.rtcCloudProxy) {
          // Enable the cloud proxy.
          $.shareScreenClient.startProxyServer(4)
        }

        $.subscribeStreamEvents($.shareScreenClient)
        await $.shareScreenClient.setClientRole('host')

        const uid = await $.shareScreenClient.join(tokenData.token, tokenData.channel, tokenData.token, tokenData.uid)

        try {
          const profile = $.$route.query.video_profile
          console.log('profile: ' + profile)
          AgoraRTC.createScreenVideoTrack({
            encodeConfig: profile,
            // Set the video transmission optimization mode as prioritizing video quality
            optimizationMode: 'detail',
            // for Firefox
            screenSourceType: 'screen'
          }, 'auto').then(async (streams) => {
            if (typeof streams.length === 'undefined') {
              $.shareScreenLocalStream = streams
              $.shareScreenLocalAudioStream = undefined
            } else {
              $.shareScreenLocalStream = streams[0]
              $.shareScreenLocalAudioStream = streams[1]
            }

            console.log('create sharing screen local audio/video track success')
            await this.addInUsers(uid)
            if ($.shareScreenLocalAudioStream) {
              console.log('sharing screen: audio truck id: ' + $.shareScreenLocalAudioStream._ID)
              $.addStream(uid, $.shareScreenLocalStream, $.shareScreenLocalAudioStream, 'audio', true)
              await $.shareScreenClient.publish($.shareScreenLocalAudioStream)
            }

            console.log('sharing screen: video truck id: ' + $.shareScreenLocalStream._ID)
            $.addStream(uid, $.shareScreenLocalStream, $.shareScreenLocalAudioStream, 'video', true)

            // set 'host' because all user must be able to streaming the video and audio(by default 'audience').
            await $.shareScreenClient.publish($.shareScreenLocalStream)
            this.isShareScreen = true
            console.log('publish success for sharing screen.')
          }).catch((e) => {
            console.error(`Share Screen error: ${e}`)
            $._leaveShareScreen()
          })
        } catch (e) {
          alert('画面シェアのvideo共有に失敗しました')
        }
      } else {
        this._leaveShareScreen()
      }
    },
    async createClientObject (token, channel, uid, isShareScreen = false) {
      const $ = this
      // // Notice: When there is no available server in Japan, the SDK throws an error instead of connecting to servers in another region.
      // AgoraRTC.setArea({
      //   areaCode: 'JAPAN'
      // })
      const client = AgoraRTC.createClient({mode: 'live', codec: 'h264'})
      if ($.rtcCloudProxy) {
        // Enable the cloud proxy.
        client.startProxyServer(4)
      }

      if (!isShareScreen) $.subscribeStreamEvents(client)

      const updatedUid = await client.join(token, channel, token, uid)

      return [client, updatedUid]
    },
    getGuestId (uid) {
      return uid
    },
    sendMessage () {
      const message = this.message.trim()
      if (message !== '') {
        this.rtmChannel.sendMessage({ text: message })
        const avatar = this.$auth.check() ? this.$auth.user().prof_img : null
        const name = this.$auth.check() ? this.$auth.user().name : `ゲスト${this.getGuestId(this.uid)}`
        this.messages = [{ message, avatar, name }, ...this.messages]
        this.message = ''
      }
    },
    handleClickSubScreenItem (uid, share = false) {
      if (uid === this.uid) return false
      this.makeSubScreen()
      this.makeMainScreen(uid, share)
    },
    makeMainScreen (uid, share = false) {
      const mainScreenContainer = document.querySelector('#main-screen .screen-container')
      let screen = null
      if (share) {
        screen = document.querySelector(`#sub-screens #share-screen-${uid}`)
      } else {
        screen = document.querySelector(`#sub-screens #screen-${uid}.active`)
        if (!screen) screen = document.querySelector(`#sub-screens #empty-screen-${uid}.active`)
      }
      if (screen) mainScreenContainer.appendChild(screen)
    },
    makeSubScreen () {
      let screen = document.querySelector('#main-screen .screen')
      if (!screen) return
      const uid = screen.id.split('-')[screen.id.split('-').length - 1]
      const subScreensContainer = document.querySelector(`#sub-screens #screen-container-${uid}`)
      subScreensContainer.appendChild(screen)
    },
    getMessageName (uid) {
      if (uid === this.meeting.user.id) return this.meeting.user.name
      const index = _.findIndex(this.participants, n => n.user_id === parseInt(uid))
      if (index === -1) return `ゲスト${this.getGuestId(uid)}`
      return this.participants[index].user_name
    },
    memberInMeeting (uid) {
      return this.participants.map(n => n.user_id).indexOf(uid) !== -1
    },
    async initChat (appId) {
      this.rtmClient = AgoraRTM.createInstance(appId)
      await this.rtmClient.login({ token: this.rtmToken, uid: this.uid.toString() })
      this.rtmChannel = this.rtmClient.createChannel(this.channel)
      await this.rtmChannel.join()
      this.rtmChannel.on('ChannelMessage', ({ text }, uid) => {
        const index = _.findIndex(this.participants, n => n.user_id === parseInt(uid))
        let avatar = null
        let name = this.getMessageName(parseInt(uid))
        if (index !== -1) avatar = this.participants[index].user_prof_img
        this.messages = [{ message: text, avatar, name }, ...this.messages]
      })
    },
    handleBeforeMeetingFinish () {
      const $ = this
      $.beforeMeetingFinish = setInterval(() => {
        if (!$.meeting) return;
        let time = -moment().diff($.meeting.end_at, 'seconds')
        time = time < 0 ? 0 : time
        if (time <= 180 && time % 30 === 0) { // (Want to reduce the load on server.)
          // confirm the end_at which be extending.
          $.handleCanExtendMeeting()
          time = -moment().diff($.meeting.end_at, 'seconds')
          if (time > 180) {
            // Found that the meeting have been extended the end_at.
            return
          }
        }

        if (time === 180) {
          alert('時間オーバーにつき、あと3分で自動で通信が削除されます。')
        } else if (time === 0) {
          try {
            $._leave()
          } catch (e) {
            console.log(e)
          }
          $.$router.push({name: 'meetings.show', id: $.meeting.id})
        }
      }, 1000)
    },
    async reloadUsers () {
      const $ = this
      _.forEach($.videoClient.remoteUsers, async user => {
        const index = _.findIndex($.users, u => u.id === user.uid)
        if (index > -1) return

        $.addInUsers(user.id)
        if (user.audioTrack && user.audioTrack.isPlaying) {
          const streamType = 'audio'
          await $.videoClient.subscribe(user, streamType)
          this.addStream(user.uid, user.videoTrack, user.audioTrack, streamType)
        }
        if (user.videoTrack && user.videoTrack.isPlaying) {
          const streamType = 'video'
          await $.videoClient.subscribe(user, streamType)
          this.addStream(user.uid, user.videoTrack, user.audioTrack, streamType)
        }
      })
    }
  },
  async created () {
    const $ = this
    let res = null
    const routeName = this.$router.currentRoute.name
    const meetingId = this.$route.params.id

    try {
      if (routeName === 'meetings.call') {
        const meetingRes = await MeetingsApi.getById(meetingId)
        const precheckMeeting = meetingRes.data.data
        if (!isJoinButtonEnabled(precheckMeeting)) {
          return this.handleJoinUnavailable(meetingId)
        }
        res = await this.$http.get(`generate-token?id=${meetingId}`)
      } else if (routeName === 'shareCall') {
        res = await this.$http.get(`generate-token?key=${this.$route.query.key}&web=1`)
      }
      const tokenData = res.data.data
      const meeting = tokenData.meeting

      this.handleBeforeMeetingFinish()

      $.token = tokenData.token
      $.rtmToken = tokenData.rtm_token
      $.channel = tokenData.channel
      // $.uid = this.$auth.user().id || tokenData.uid
      $.uid = tokenData.uid

      const meetingRes = await MeetingsApi.getById(meeting.id, meeting.key)
        .catch((error) => {
          apiErrorDialog(this, error)
        })
      $.meeting = meetingRes.data.data
      const index = _.findIndex($.meeting.organizer, n => n.user_id === this.$auth.user().id)
      $.isMeetingOrganizer = index !== -1

      const masterDataApi = await MasterDataApi.get()
        .catch((error) => {
          apiErrorDialog(this, error)
        })
      const masterData = masterDataApi.data.data
      $.rtcCloudProxy = masterData.agora_cloud_proxy
      $.additionalTimeMinutes = masterData.additional_time_minutes_online

      if ($.meeting.category_type === MEETING_CATEGORY_MEDICATION) {
        $.additionalTimeMinutes = masterData.additional_time_minutes_reservation
        $.showOnOffVideo = false
      }

      // // Notice: When there is no available server in Japan, the SDK throws an error instead of connecting to servers in another region.
      // AgoraRTC.setArea({
      //   areaCode: 'JAPAN'
      // })
      $.videoClient = AgoraRTC.createClient({mode: 'live', codec: 'h264'})
      if ($.rtcCloudProxy) {
        // Enable the cloud proxy.
        $.videoClient.startProxyServer(4)
      }

      $.subscribeStreamEvents($.videoClient)

      const uid = await $.videoClient.join($.token, $.channel, $.token, $.uid)

      await $.videoClient.setClientRole('host')

      try {
        const profile = $.$route.query.video_profile
        $.videoLocalStream = await AgoraRTC.createCameraVideoTrack({
          encodeConfig: profile
        })
      } catch (e) {
        console.log(e)
        alert('カメラの読み込みに失敗しました')
      }
      $.audioLocalStream = await AgoraRTC.createMicrophoneAudioTrack()
      await this.addInUsers(uid)
      $.addStream(uid, $.videoLocalStream, $.audioLocalStream, 'audio')
      if ($.videoLocalStream) $.addStream(uid, $.videoLocalStream, $.audioLocalStream, 'video')

      // set 'host' because all user must be able to streaming the video and audio(by default 'audience').
      if ($.videoLocalStream) await $.videoClient.publish($.videoLocalStream)
      await $.videoClient.publish($.audioLocalStream)
      console.log('publish success.')
      $.readyState = true

      $.participants = []
      $.participants = [...$.meeting.participants]
      $.participants.push({
        address: this.meeting.user.address,
        occupation: this.meeting.user.occupation,
        status: this.meeting.user.status,
        user_account: this.meeting.user.account,
        user_id: this.meeting.user.id,
        user_name: this.meeting.user.name,
        user_name_k: this.meeting.user.name_k,
        user_prof_img: this.meeting.user.prof_img,
        user_type: this.meeting.user.type
      })

      this.handleCanExtendMeeting()
      this.handleRamainTimes()

      $.initChat(tokenData.app_id)

      if (this.$auth.check()) {
        await MeetingsApi.join(this.meeting.id)
          .catch((error) => {
            apiErrorDialog(this, error)
          })
      }
    } catch (e) {
      console.log('立ち上げに失敗しました', e)
      if (e.response && e.response.status === 404) {
        const unavailableMeetingId = meetingId || (this.meeting && this.meeting.id)
        return this.handleJoinUnavailable(unavailableMeetingId)
      }
      if (!$.audioLocalStream) {
        let modalMessage = 'オーディオ機器の情報を取得できなかったため、終了します';
        let modalTitle = '';
        $.$alert(modalMessage,modalTitle,{
          confirmButtonText: '予約詳細へ戻る',
          cancelButtonText: '',
          forceRender: true,
          type: 'warning'
        }).then(() => {
          let loading = $.$loading.show({opacity: 1})
          $._leave()
          setTimeout(() => {
            this.$router.push({name: 'meetings.show', id: this.meeting.id})
            loading.hide()
          }, 1000)
        })
      } else {
        $.$router.push({name: 'home'})
      }
    }
  },
  destroyed () {
    try {
      if (!this.endMeetingConfirmed) {
        this._leave()
      }
    } catch (e) {
      console.log(e)
    }
    clearInterval(this.beforeMeetingFinish)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Call.vue